/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: 'Suchen',
  search_no_results_1: 'Oh nein!',
  search_no_results_2: 'Dieses Emoji wurde nicht gefunden',
  pick: 'Emoji auswählen…',
  add_custom: 'Benutzerdefiniertes Emoji hinzufügen',
  categories_activity: 'Aktivität',
  categories_custom: 'Benutzerdefiniert',
  categories_flags: 'Flaggen',
  categories_foods: 'Essen und Trinken',
  categories_frequent: 'Häufig verwendet',
  categories_nature: 'Tiere und Natur',
  categories_objects: 'Objekte',
  categories_people: 'Smileys und Personen',
  categories_places: 'Reisen und Orte',
  categories_search: 'Suchergebnisse',
  categories_symbols: 'Symbole',
  skins_choose: 'Standardhautfarbe auswählen',
  skins_1: 'Standard',
  skins_2: 'Hell',
  skins_3: 'Mittel bis hell',
  skins_4: 'Mittel',
  skins_5: 'Mittel bis dunkel',
  skins_6: 'Dunkel',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
